/* istanbul ignore file */
import { CopyToClipboardButton } from 'framework/ui/clipboard';
import { TextField, useFieldHelper } from 'framework/ui/field';

const ProcessInstanceIdField = (props: any) => {
  const { getValue } = useFieldHelper(props);
  const id = getValue();

  const value = (
    <>
      <span>{id}</span>
      <CopyToClipboardButton sx={{ ml: 0.5 }} id="copyProcessInstanceId" value={id}>
        Copy process instance id
      </CopyToClipboardButton>
    </>
  );

  return <TextField {...props} value={value} />;
};

export default ProcessInstanceIdField;
